import * as nodes from './nodes';
const typedNodes = nodes;
export const inlineNodes = new Set(Object.keys(typedNodes).filter(key => typedNodes[key] && typedNodes[key].group === 'inline'));